import { View } from "@react-pdf/renderer";
import {
  ResumePDFSection,
  ResumePDFText,

} from "components/Resume/ResumePDF/common";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import type { ResumeLanguage } from "lib/redux/types";
import {
  ResumePDFDescription,
  TemplateFourteenPDFSectionWithSubsections,
} from "./common";

export const Language = ({
  heading,
  languages,
  themeColor,
  isPDF,
}: {
  heading: string;
  languages: ResumeLanguage[];
  themeColor: string;
  isPDF: boolean;
}) => {
  return (
    <TemplateFourteenPDFSectionWithSubsections themeColor={themeColor} heading={heading}>
      {languages.map(({ language, level, descriptions }, idx) => (
        <View
          key={idx}
          style={idx !== 0 ? { marginTop: spacing["3"] } : {}}
          wrap={false}
        >
          <View
            style={{
              ...styles.flexRowBetween,
              marginTop: spacing["0.5"],
            }}
          >
            <View
              style={{
                ...styles.flexRow,
                gap: spacing["2"],
              }}
            >
              <ResumePDFText  bold={true}>
                {language}
              </ResumePDFText>
              <ResumePDFText >{level}</ResumePDFText>
            </View>
          </View>
          <View style={{ ...styles.flexCol, marginTop: spacing["0.5"] }}>
            <ResumePDFDescription items={descriptions} />
          </View>
        </View>
      ))}
    </TemplateFourteenPDFSectionWithSubsections>
  );
};
